export default __webpack_public_path__ + "assets/enterprise-one-four-small.e52c71cbbb6bb8621419a77bb67afcef.png";